document.addEventListener('DOMContentLoaded', function() {
  CompareModal.init();
});

const CompareModal = {
    selectors: {
      "parent": { "selector": ".paddle-comparison", "type": "single", "scope": "document" },
      "compareModal": { "selector": "#compare-modal", "type": "single", "scope": "document" },
      "closeModalBtn": { "selector": ".close-compare", "type": "single", "scope": "document" },
      "toggleCompareModal": { "selector": "#toggle-compare-modal", "type": "single", "scope": "document" },
      "compareButtons": { "selector": ".compare-button", "type": "all", "scope": "document" },
      "compareInfo": { "selector": "#compare-info", "type": "single", "scope": "document" },
      "selectedNum": { "selector": "#selected-num", "type": "single", "scope": "document" },
      "compareError": { "selector": ".compare-error", "type": "single", "scope": "document" },
      "productsContainer": { "selector": "#selected-products", "type": "single", "scope": "document" },
      "placeholderCards": { "selector": ".placeholder-card", "type": "all", "scope": "document" },
      "errorMessage":  { "selector": ".compare-error", "type": "single", "scope": "document" },
      "plusIcon": { "selector": ".hidden-icon-plus", "type": "single", "scope": "document" },
      "checkIcon": { "selector": ".hidden-icon-check", "type": "single", "scope": "document" },
      "closeIcon": { "selector": ".hidden-icon-close", "type": "single", "scope": "document" },
    },

    init: async function() {
        Utility.fetchEls(this.selectors, this);
        
        this.calculatePaddleLimit();
        this.selectedProducts = JSON.parse(sessionStorage.getItem('selectedProducts')) || [];  
        const {selectedPaddlesLimit, selectedProducts } = this;
        if (selectedProducts.length > selectedPaddlesLimit) {
          this.maxProductsExceeded();
        }
        
        if (selectedPaddlesLimit === selectedProducts.length) {
            this.maxProductsSelected();
        }

        this.initEventListeners();

        // call updateButtonsUI on page load to set up checks & modal for already selected products 
        this.updateButtonsUI(true, selectedPaddlesLimit);  
  
    },
    initEventListeners: function() {
      const { 
        closeModalBtn, 
        compareModal, 
        toggleCompareModal, 
        compareButtons, 
        selectedPaddlesLimit, 
        selectedNum, 
        closeIcon, 
        errorMessage 
      } = this;
      
      closeModalBtn.addEventListener('click', () => {
        this.closeCompareModal();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeCompareModal();
        }
      });

      // this.newObserver();

      let resizeTimeout;
      window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
              this.selectedPaddlesLimit = this.calculatePaddleLimit();
              if (window.getComputedStyle(compareModal).display !== 'none') {
                this.setModalHeight(errorMessage.style.display !== 'none');
              }
          }, 100);
      });

      toggleCompareModal.addEventListener('click', () => {
          const currentDisplay = window.getComputedStyle(compareModal).display;
          if (currentDisplay === 'none') {
            compareModal.style.display = 'block';
            toggleCompareModal.classList.add('active-border');
            this.setModalHeight(errorMessage.style.display !== 'none');
            this.scrollModalToBottom();
          } else {
            this.closeCompareModal();
          }
        });

      compareButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.handleButtonClick(btn, selectedPaddlesLimit);
        });
      });
    },
    newObserver: function() {
        const { productGrid, selectedPaddlesLimit } = this;
        const config = { childList: true };
        const callback = function(mutationsList, observer) {
            for(const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    this.updateButtonsUI(false, selectedPaddlesLimit);
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(productGrid, config);
    },
    maxProductsSelected: function() {
        const { compareModal, toggleCompareModal } = this;
        // if you've selected the max number of products, display the modal and limit message
        compareModal.style.display = 'block';
        toggleCompareModal.classList.add('active-border');
        this.displayLimitMessage();
    },
    maxProductsExceeded: function() {
        let { selectedProducts, selectedPaddlesLimit } = this;
        // if more products selected than the limit, remove the extras
        selectedProducts = selectedProducts.slice(0, selectedPaddlesLimit);
        sessionStorage.setItem('selectedProducts', JSON.stringify(selectedProducts));
    },
    calculatePaddleLimit: function() {
        let limit = 3;
        if (window.innerWidth < 769) {
            limit = 2;
            document.querySelector('#compare-info').innerHTML = 'Select <strong>up to 2</strong> paddles to compare.';
        }
        this.selectedPaddlesLimit = limit;
        return limit;
    },

    isMobileLandscape: function() {
      return window.matchMedia('(orientation: landscape) and (max-height: 600px)').matches;
    },

    getMaxModalHeight: function() {
      if (this.isMobileLandscape()) {
        const bottomOffset = 55;
        const topClearance = 16;
        return window.innerHeight - bottomOffset - topClearance;
      }

      const bottomOffset = 85;
      const headerClearance = 120;
      return window.innerHeight - bottomOffset - headerClearance;
    },

    setModalHeight: function(withErrorMessage) {
      const { compareModal } = this;
      const isMobile = window.innerWidth <= 768;
      const isLargeScreen = window.innerWidth > 1400;
      const maxHeight = this.getMaxModalHeight();

      let preferred;
      if (this.isMobileLandscape()) {
        preferred = maxHeight;
      } else if (isMobile) {
        preferred = withErrorMessage ? 320 : 280;
      } else if (isLargeScreen) {
        preferred = withErrorMessage ? 580 : 520;
      } else {
        preferred = withErrorMessage
          ? window.innerHeight * 0.6
          : window.innerHeight * 0.68;
      }

      const height = Math.min(preferred, maxHeight);
      compareModal.style.height = `${height}px`;
      compareModal.style.maxHeight = `${maxHeight}px`;
      compareModal.style.overflowY = this.isMobileLandscape() ? 'auto' : '';
    },

    scrollModalToBottom: function() {
      const { compareModal } = this;
      clearTimeout(this._scrollTimeout);
      compareModal.scrollTop = 0;
      if (compareModal.scrollHeight - 10 <= compareModal.clientHeight) return;

      this._scrollTimeout = setTimeout(() => {
        requestAnimationFrame(() => {
          compareModal.scrollTo({ top: compareModal.scrollHeight, behavior: 'smooth' });
        });
      }, 300);
    },

    closeCompareModal: function() {
      const { compareModal, toggleCompareModal } = this;
      if (window.getComputedStyle(compareModal).display === 'none') return;
      clearTimeout(this._scrollTimeout);
      compareModal.style.display = 'none';
      toggleCompareModal.classList.remove('active-border');
    },

    displayLimitMessage: function() {
      const { errorMessage } = this;
      errorMessage.style.display = 'block';
      this.setModalHeight(true);
    },

    hideLimitMessage: function() {
      const { errorMessage } = this;
      errorMessage.style.display = 'none';
      this.setModalHeight(false);
    },

    updateButtonsUI: function(updateModal) {
      // gets called on page load

      const { selectedProducts, compareButtons, compareModal, toggleCompareModal, selectedNum, selectedPaddlesLimit } = this;
      
      // set buttons to selected if the product is already saved in sessionStorage
      if (selectedProducts.length) {
        selectedProducts.forEach((product) => {
          compareButtons.forEach((button) => {
            if (button.dataset.handle === product.handle) {
              button.dataset.selected = 'true';
            }
          });
          if (updateModal)
          {
            this.updateCompareModal(product.handle, product.variantId);
          }          
        });
      }
      
      // update buttons to show checkmark if they are already selected
      compareButtons.forEach((checkbox) => {
        let isSelected = checkbox.dataset.selected == 'true';
        if (isSelected) {
          this.updateCheckboxIcon(checkbox);
        }
      });
      
      // count how many paddles have been selected by checking length of local storage
      let selectedPaddlesCount = selectedProducts.length;
      
      // if any paddles are already saved in sessionStorage, display the compare modal button
      if (selectedPaddlesCount > 0) {
        selectedNum.textContent = selectedPaddlesCount + '/' + selectedPaddlesLimit;
        toggleCompareModal.style.display = 'flex';
      }
      if (selectedPaddlesCount === selectedPaddlesLimit) {
        compareModal.style.display = 'block';
        toggleCompareModal.classList.add('active-border');
        this.displayLimitMessage();
      } 
    },

    handleButtonClick: function(compareButton){
      const { selectedProducts, selectedPaddlesLimit, selectedNum, toggleCompareModal, compareModal } = this;
      let checkbox = compareButton;
      
      // each time we click a compare button, check what paddles are already selected 
      let selectedPaddlesCount = selectedProducts.length;
      let isSelected = checkbox.dataset.selected == 'true';
    
      // if the paddle is NOT already selected and the current # selected is less than the limit, add this paddle to compare
      if (!isSelected && selectedPaddlesCount < selectedPaddlesLimit) {
        checkbox.dataset.selected = 'true';
        selectedPaddlesCount++;
        selectedNum.textContent = selectedPaddlesCount + '/' + selectedPaddlesLimit;
        if (selectedPaddlesCount == 1) {
          toggleCompareModal.style.display = 'flex';
        } else if (selectedPaddlesCount == selectedPaddlesLimit) {
          compareModal.style.display = 'block';
          toggleCompareModal.classList.add('active-border');
          this.displayLimitMessage();
        }
        this.updateCheckboxIcon(checkbox);
        this.updateSessionStorage(checkbox.dataset.handle, checkbox.dataset.variantId, "add");
      } 
      // If it is selected, we can deselect it regardless of how many are selected
      else if (isSelected) {
        checkbox.dataset.selected = 'false';
        this.hideLimitMessage();
        if (selectedPaddlesCount === 0) {
          this.closeCompareModal();
        }
        selectedPaddlesCount--;
        selectedNum.textContent = selectedPaddlesCount + '/' + selectedPaddlesLimit;
        this.updateCheckboxIcon(checkbox);
        this.updateSessionStorage(checkbox.dataset.handle, checkbox.dataset.variantId, "remove");
      }
    },

    updateCheckboxIcon: function(checkbox) {
      const { plusIcon, checkIcon } = this;
      const plusIconTemplate = plusIcon.cloneNode(true);
      plusIconTemplate.className = 'plus-icon';
      const checkIconTemplate = checkIcon.cloneNode(true);
      checkIconTemplate.className = 'check-icon';
    
      if (checkbox) {
        checkbox.innerHTML = '';
        if (checkbox.dataset.selected == 'true') {
          // Append check icon
          checkbox.appendChild(checkIconTemplate);
        } else {
          // Append plus icon
          checkbox.appendChild(plusIconTemplate);
        }
      }
    },

    getComparePriceData: function(productHandle, variantId) {
      const stored = (this.selectedProducts || []).find((product) => {
        return product.handle === productHandle && String(product.variantId) === String(variantId);
      });
      const button = document.querySelector(`.compare-button[data-handle="${productHandle}"][data-variant-id="${variantId}"]`)
        || document.querySelector(`.compare-button[data-handle="${productHandle}"]`);
      const card = document.querySelector(`.product-card[data-handle="${productHandle}"]`);

      return {
        price: Number(stored?.price || button?.dataset.price || card?.dataset.presentmentPrice || card?.dataset.price || 0),
        priceFormatted: stored?.priceFormatted || button?.dataset.priceFormatted || ''
      };
    },

    formatComparePrice: function(productHandle, variantId, fallbackCents) {
      const { price, priceFormatted } = this.getComparePriceData(productHandle, variantId);
      if (priceFormatted) {
        return priceFormatted;
      }

      const cents = Number(price || fallbackCents || 0);
      if (typeof Utility !== 'undefined' && typeof Utility.formatLocalizedMoney === 'function') {
        return Utility.formatLocalizedMoney(cents);
      }

      const symbol = window.SelkirkStore?.currencySymbol || '$';
      return `${symbol}${(cents / 100).toFixed(2).replace(/\.00$/, '')}`;
    },

    updateSessionStorage(productHandle, variantId, operation) {
      // get products currently in local storage
      let { selectedProducts } = this;
      const priceData = this.getComparePriceData(productHandle, variantId);
    
      const productToUpdate = {
        handle: productHandle,
        variantId: variantId,
        price: priceData.price,
        priceFormatted: priceData.priceFormatted
      };
    
      if (operation === 'add') {
        // Check if productToAdd is already in the selectedProducts array
        const isProductAdded = selectedProducts.some(product => product.variantId === productToUpdate.variantId);
    
        // If the product is not added, add it to the array and save back to sessionStorage
        if (!isProductAdded) {
            selectedProducts.push(productToUpdate);
        } 
      } else {
          selectedProducts = selectedProducts.filter(product => product.variantId !== variantId);
      }
      
      // save local storage 
      sessionStorage.setItem('selectedProducts', JSON.stringify(selectedProducts));
      this.selectedProducts = JSON.parse(sessionStorage.getItem('selectedProducts')) || [];  
      this.updateCompareModal(productHandle, variantId);
    },

    updateCompareModal: async function(productHandle, variantId) {
      const { 
        compareButtons, 
        selectedProducts,
        selectedPaddlesLimit, 
        productsContainer, 
        closeIcon,
        selectedNum,
        compareModal,
        toggleCompareModal,
        productCards
       } = this;
      
      let selectedPaddlesCount = selectedProducts.length;
            
      // if we are ADDING a product to the compare modal, remove a placeholder card
      if (selectedProducts.some((product) => product.variantId === variantId)) {
        // fetch product data
        try {
          const response = await fetch(`/products/${productHandle}.js`);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const productData = await response.json();
          let curVariant = productData.variants.find((variant) => variant.id == variantId);
          const newProductCard = document.createElement('div');
          newProductCard.classList.add('compare-product-card');
          newProductCard.setAttribute('data-variant-id', variantId);
          const productImgContainer = document.createElement('div');
          productImgContainer.classList.add('compare-img-container');
          productImgContainer.innerHTML = `<img src="${curVariant.featured_image ? curVariant.featured_image.src : productData.featured_image}" class="compare-img" alt="${productData.title}">`;
          newProductCard.appendChild(productImgContainer);
          let productTitle = productData.title;
          if (productTitle.includes(' - Pickleball Paddle')) {
            productTitle = productData.title.replace(' - Pickleball Paddle', '');
          }
          if (productTitle.includes('SLK by Selkirk x')) {
            productTitle = productTitle.replace('SLK by Selkirk x', 'SLK x');
          } else if (productTitle.includes('SLK by Selkirk')) {
            productTitle = productTitle.replace('SLK by Selkirk', 'SLK');
          } else if (productTitle.includes('Selkirk') && !productTitle.includes('Selkirk x')){
            productTitle = productTitle.replace('Selkirk', '');
          }
          const productPrice = this.formatComparePrice(productHandle, variantId, curVariant.price || productData.price);
          const productDetailsContainer = document.createElement('div');
          productDetailsContainer.classList.add('compare-product-details');
          productDetailsContainer.innerHTML = `
            <h3 class="compare-title">${productTitle}</h3>
            <p class="compare-price">${productPrice}</p>
          `;
          newProductCard.appendChild(productDetailsContainer);
          const closeIconTemplate = closeIcon.cloneNode(true);
          closeIconTemplate.className = 'close-icon';
          closeIconTemplate.setAttribute('data-variant-id', variantId);
          closeIconTemplate.setAttribute('data-product-handle', productHandle);
          closeIconTemplate.addEventListener('click', () => {
            let selectedPaddlesCount = selectedProducts.length;
            let checkbox;
            compareButtons.forEach((button) => {
              if (button.dataset.handle === productHandle) {
                checkbox = button;
                button.dataset.selected = 'false';
              }
            });
            if (selectedPaddlesCount === selectedPaddlesLimit) {
              this.hideLimitMessage();
            }
            selectedPaddlesCount--;
            if (selectedPaddlesCount === 0) {
              this.closeCompareModal();
            }
            selectedNum.textContent = selectedPaddlesCount + '/' + selectedPaddlesLimit;
            if (checkbox)
            {
              this.updateCheckboxIcon(checkbox);
            }        
            this.updateSessionStorage(productHandle, variantId, "remove");
          });
          // add the new product card to the compare modal
          newProductCard.appendChild(closeIconTemplate);
          productsContainer.prepend(newProductCard);
          const productCards = document.querySelectorAll('.compare-product-card');
          for (let card of productCards) {
            if (productCards.length != selectedPaddlesLimit) {
              if (card.classList.contains('placeholder-card')) {
              card.remove();
              if(selectedPaddlesCount != selectedPaddlesLimit) {
                break;
              }
            }
          } 
        }
          if (selectedPaddlesCount === selectedPaddlesLimit && compareModal.style.display !== 'none') {
            this.scrollModalToBottom();
          }
        } catch (error) {
          console.error('Error fetching product data:', error);
          return null;
        }
      } else {
        // if the passed in product is NOT in local storage and in the modal, remove it 
        const productCards = document.querySelectorAll('.compare-product-card');
        productCards.forEach((card) => {
          if (card.dataset.variantId == variantId) {
            card.remove();
            const newProductCard = document.createElement('div');
            newProductCard.classList.add('compare-product-card');
            newProductCard.classList.add('placeholder-card');
            productsContainer.appendChild(newProductCard);
          }
        });
      }
    } 
};